<template lang="pug">
  .cart
    .cart__contents(v-if="totalItems > 0", key="contents")
      .cart-title-wrapper
        h1.cart__title.h3 Shopping Cart
        a.cart__title-link(
          v-if="$mq !== 'mobile'"
          :href="emptyButtonLink"
        ) Continue Shopping
      sidecart-line-item(
        v-for="(item, index) in items"
        :item="item"
        :line="index + 1"
        :key="item.id"
      )
    .cart__empty(
      v-else
      key="empty"
    )
      h1.cart__title.h3 Shopping Cart
      p.cart__empty__text {{ emptyText }}
      link-button(
        :href="emptyButtonLink"
        :label="emptyButtonText"
      )
    .cart__sidebar(
      v-if="totalItems > 0"
    )
      p.cart__total
        | Subtotal:
        span.cart__total-amount {{ totalPrice | money }}
      checkout-button.cart__checkout-cta(
        label="Checkout"
        name="checkout"
      )
      .cart__free-shipping {{ freeShippingBarContent }}
      a.cart__keep-shopping-link(
        v-if="$mq === 'mobile'"
        :href="emptyButtonLink"
      ) Continue Shopping
</template>

<script>
  import { mapState } from 'vuex';
  import { gwpTypes, gwpStorageCancelledKeys } from 'scripts/config/gwp.js';

  import PrimaryButton from 'scripts/components/buttons/PrimaryButton.vue';
  import CheckoutButton from 'scripts/components/buttons/CheckoutButton.vue';
  import LinkButton from 'scripts/components/buttons/LinkButton.vue';
  import SidecartLineItem from 'scripts/components/cart/SidecartLineItem.vue';

  export default {
    name: 'Cart',
    components: {
      PrimaryButton,
      CheckoutButton,
      LinkButton,
      SidecartLineItem,
    },
    props: {
      emptyText: String,
      emptyButtonLink: String,
      emptyButtonText: String,
      freeShippingThreshold: Number,
      freeShippingText: String,
    },
    computed: {
      ...mapState({
        allProducts: state => state.products.all,
        items: state => state.cart.checkout.items,
        itemsSubtotal: state => state.cart.checkout.items_subtotal_price,
        totalDiscount: state => state.cart.checkout.total_discount,
        totalPrice: state => state.cart.checkout.total_price,
        totalItems: state => state.cart.checkout.item_count,
      }),
      hasSubscriptionItems () {
        return this.items && this.items.filter(item => {
          return item.properties && !!item.properties._base_product
        }).length >= 1
      },
      freeShippingBarContent () {
        const totalInDollars = this.totalPrice / 100.0;
        const amountRemaing = (this.freeShippingThreshold - totalInDollars).toFixed(2);
        return amountRemaing <= 0 ? this.freeShippingText : `Add $${amountRemaing} for Free Shipping`;
      },
    },
    watch: {
      hasSubscriptionItems (newVal, oldVal) {
        if (oldVal && !newVal) {
          location.reload(true)
        }
      }
    },
    methods: {
      cancelThresholdProduct () {
        window.sessionStorage.setItem(GWP_THRESHOLD_CANCELLED_KEY, 'true');
      },
    },
  };
</script>

<style scoped lang="scss">
  .cart {
    margin: 30px 0 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include tablet-up() {
      margin: 100px 0 150px;
      flex-direction: row;
    }

    &__title {
      margin-bottom: 0;
      text-align: center;
      color: $color-indigo;

      @include tablet-up() {
        text-align: left;
      }
    }

    &__checkout-cta {
      width: 100%;
    }

    &__product-header {
      text-align: left;
    }

    &__total,
    &__subtotal,
    &__discount {
      text-align: right;
      margin-bottom: 10px;
    }

    td,
    th {
      &:not(:first-child) {
        padding-left: $grid-gutter / 2;
      }

      &:not(:last-child) {
        padding-right: $grid-gutter / 2;
      }
    }

    &__empty {
      padding: 40px 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      &__text {
        font-size: rem(20);
        line-height: 1.5;
        font-family: $font-gibson;
      }

      &__image,
      &__text {
        margin: 0 0 24px;
      }
    }
  }

  @include tablet-up() {
    .cart__sidebar {
      padding-top: 80px;
      width: 338px;
      margin-left: 135px;
    }
  }

  .cart__total {
    display: flex;
    justify-content: space-between;
    font-family: $font-gibson;
    font-size: rem(16);
    line-height: 1.6;
    color: $color-charcoal;
  }

  .cart__free-shipping {
    padding: 15px 0;
    text-align: center;
    font-family: $font-gibson;
  }

  .cart__contents {
    width: 456px;
    max-width: 100%;

    @include mobile-only {
      margin: auto;
    }
  }

  .cart-title-wrapper {
    margin-bottom: 32px;
    display: flex;
    justify-content: center;
    align-items: baseline;

    @include desktop-up {
      margin-bottom: 54px;
      justify-content: space-between;
    }
  }

  .cart__keep-shopping-link,
  .cart__title-link {
    margin-top: 5px;
    font-weight: 400;
    font-family: $font-gibson;

    &:hover {
      text-decoration: underline;
    }
  }

  .cart__keep-shopping-link {
    display: block;
    text-align: center;
  }
</style>
